import type { ActivityType, AllOption } from '@/ui/types';
import { canUseIntersectionObserverV2 } from '@/ui/utils/document';

export const ACTIVITY_TYPES: ActivityType[] = [
  { key: 'received', icon: 'arrow-down-left', label: 'Received' },
  { key: 'sent', icon: 'arrow-up-right', label: 'Sent' },
  { key: 'exchanged', icon: 'arrow-left-arrow-right', label: 'Swapped' },
];

/** Symbol to identify the "All" option in picker modals. */
export const ALL_OPTION: AllOption = Symbol('ALL_OPTION');

export { default as campaigns } from './campaigns.js';
export * from './campaigns.js';

export const EMBEDDABLE_SIGNER =
  __STANDALONE_MODE__ &&
  __EMBEDDABLE_SIGNER__ &&
  (__EMBEDDABLE_SIGNER_SKIP_OBSERVER_CHECK__ || canUseIntersectionObserverV2());
